import { create } from "zustand";

export const useCommmonStore = create((set) => ({
  profileDetail: null,
  setProfileDetail: (data) => set({ profileDetail: data }),
}));
